import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-cream-white pt-20">
      <div className="container mx-auto px-6 py-24">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-serif text-5xl md:text-7xl text-charcoal mb-6 animate-fade-in">
            Путь к себе начинается здесь
          </h1>
          <p className="text-lg md:text-xl text-warm-gray mb-12 max-w-2xl mx-auto leading-relaxed">
            Профессиональная психологическая помощь и арт-терапия для тех, кто готов меняться и расти
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button onClick={scrollToConsultation} className="btn-primary group">
              Записаться на консультацию
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </button>
            <a href="#about" className="btn-secondary">
              Узнать больше
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
